module.exports = __webpack_public_path__ + "img/MTABAPPABP.99aa21d0.jpg";